<template>
    <v-container class="pb-6">
        <user-form
            :model="user"
            @saved="saved"
            :isEdit="true"
            :titlePrefix="$t('users-edit.texts.title-prefix')"
            v-if="user"
        ></user-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import UserModel from '@/models/User'
import UserForm from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            user: null,
        }
    },

    components: {
        'user-form': UserForm,
    },

    methods: {
        async getUser() {
            let user = await this.model.find(this.id)

            this.user = user
        },

        saved() {
            this.$router.push({ name: 'user.index' })
        },
    },

    computed: {
        model() {
            return new UserModel()
        },
    },

    created() {
        this.getUser()
    },
}
</script>
